import conceptPageIds from '../modules/templates/constants/concept-page-ids';
import isOnlineStoreTemplate from '../modules/templates/verifiers/is-online-store-template';

const getConceptId = (currentTemplate) =>
  isOnlineStoreTemplate(currentTemplate) ? conceptPageIds.ONLINE_STORE : conceptPageIds.DEFAULT;

export default getConceptId;
